export const getProducts = (payload?: { page?: number, search?: string, isDeleted: boolean }) => ({
    type: "@saga/GET_PRODUCTS",
    payload
});